import logo from './logo.svg';
import './App.css';
import PrivateRoutes from './routes/PrivateRoutes';
import {Route, Routes} from 'react-router-dom';
import Login from './components/Login';
import OtpVerification from './components/OtpVerification';
import ForgotPassword from './components/ForgotPassword';
import Features from './components/Features'
import SearchRes from './components/SearchRes';
import ResetPassword from './components/ResetPassword'
import Test from './components/Test'
import Header from './components/common/Header';
import HeaderFeatures from './components/common/HeaderFeatures';
import Footer from './components/common/footer'
import ChangePassword from './components/ChangePassword'
import PrivacyPolicy from './components/PrivacyPolicy'
import TermsCondition from './components/TermsCondition'
import FAQ from './components/FAQ'
import SearchTest from './components/SearchTest';



function App() {
  return (
    <div className="App">       
       <Routes>
        <Route path="/" element={<Login />} />
        <Route path="otp-verification" element={<OtpVerification />} />       
        <Route path="forgot-password" element={<ForgotPassword />} />  
        <Route path="reset-password/:token" element={<ResetPassword />} />  
        <Route path="test/:id" element={<Test />} />  
        <Route exact element={<PrivateRoutes />}>     
          <Route path="features" element={
            <>
            <HeaderFeatures/>
              <div className='content'>
                <Features />
              </div>
            <Footer/>
            </>
          } /> 

          <Route path="search" element={
            <>
            <HeaderFeatures/>
              <div className='content'>
                <SearchRes />
              </div>
            <Footer/>
            </>
          } /> 


        <Route path="search-res" element={
          <>
            <HeaderFeatures/>
            <div className='content'>
              <SearchTest />
            </div>
            <Footer/>
            
          </>
            } /> 

          
          <Route path="change-password" element={
            <>
            <Header/>
            <ChangePassword/>
            </>          
          } />

          <Route path="privacy-policy" element={
            <>
            <Header/>
            <div className='content'>
              <PrivacyPolicy/>
            </div>
            <Footer/>
            </>          
          } />

          <Route path="terms-condition" element={
            <>
            <Header/>
            <div className='content'>
              <TermsCondition/>
            </div>
            <Footer/>
            </>          
          } />
          
        <Route path="faq" element={
            <>
            <Header/>
            <div className='content'>
            <FAQ/>
            </div>
            <Footer/>
            </>          
          } />
        </Route>
        <Route path="/*" element={<Login />} /> 
      </Routes>
      
    </div>
  );
}

export default App;
